import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { useForkRef, useIsomorphicLayoutEffect } from '@cian/react-utils';
import { useUpdateEffect } from '../../../internal/hooks';
import { DropdownPopover } from '../../../popover';
import { SelectInput, useControlledValue } from '../../internal';
import { useSelectDesktopController } from './useSelectDesktopController';
import { SelectDesktopDropdown } from './SelectDesktopDropdown';
import { processSelectKeyboardEvent } from './processSelectKeyboardEvent';

/**
 * select-компонент для выбора одного значения из списка
 *
 * Только десктопный вариант, открывающий выпадающий список
 */
export var SelectDesktop = /*#__PURE__*/React.forwardRef(function SelectDesktop(props, forwardedRef) {
  var onClick = props.onClick,
    selectInputProps = _objectWithoutProperties(props, _excluded);
  var inputRef = React.useRef(null);
  var ref = useForkRef(forwardedRef, inputRef);
  var _useControlledValue = useControlledValue(props, null),
    value = _useControlledValue.value,
    onChange = _useControlledValue.onChange;
  var _useSelectDesktopCont = useSelectDesktopController(_objectSpread(_objectSpread({}, props), {}, {
      value: value,
      onChange: onChange
    })),
    open = _useSelectDesktopCont.open,
    focusedIndex = _useSelectDesktopCont.focusedIndex,
    actions = _useSelectDesktopCont.actions;
  useUpdateEffect(function () {
    var inputNode = inputRef.current;
    if (!open && inputNode) {
      inputNode.focus();
    }
  }, [open], useIsomorphicLayoutEffect);
  var handleInputClick = React.useCallback(function (e) {
    if (onClick) {
      onClick(e);
    }
    if (!e.defaultPrevented) {
      e.stopPropagation();
      actions.toggleDropdown();
    }
  }, [actions, onClick]);
  var handleKeyDown = React.useCallback(function (e) {
    processSelectKeyboardEvent(e, {
      open: open,
      actions: actions
    });
  }, [open, actions]);
  return /*#__PURE__*/React.createElement(DropdownPopover, {
    open: open,
    content: /*#__PURE__*/React.createElement(SelectDesktopDropdown, _extends({}, props, {
      open: open,
      onKeyDown: handleKeyDown,
      focusedIndex: focusedIndex,
      actions: actions
    }))
  }, /*#__PURE__*/React.createElement(SelectInput, _extends({}, selectInputProps, {
    ref: ref,
    open: open,
    onClick: handleInputClick,
    onKeyDown: handleKeyDown,
    role: "button",
    "aria-haspopup": "listbox",
    value: value
  })));
});